/**
 * Zawsze zwraca pełny URL bazy API (bez trailing slash).
 * W przeglądarce na produkcji używa origin bieżącej strony
 * (obsady.stagecontrol.pl albo alias Vercel), żeby UI nie wołało innego projektu.
 */
export function getApiBase() {
  if (typeof window !== 'undefined' && window.location?.hostname) {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return 'http://localhost:3001';
    }
    return String(window.location.origin || '').replace(/\/$/, '');
  }
  const env = process.env.REACT_APP_API_BASE;
  const base = typeof env === 'string' ? env.replace(/\/$/, '') : '';
  if (base && base.startsWith('http')) return base;
  return 'https://obsady.stagecontrol.pl';
}
